import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';

import * as OrganizationActions from '../actions/organization.actions';
import {OrganizationsService} from '../../../services/api/organizations/organizations.service';
import {Organization} from '../../../services/api/organizations/models/organization.model';


@Injectable()
export class OrganizationEffects {

  // noinspection JSUnusedGlobalSymbols
  loadOrganization$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(OrganizationActions.loadOrganization),
      concatMap((payload) =>
        this.service.getOrganization(payload.data)
          .pipe(
            map((data: Organization) => OrganizationActions.loadOrganizationSuccess({data})),
            catchError(error => of(OrganizationActions.loadOrganizationFailure({error})))
          )
      )
    );
  });


  constructor(
    private readonly actions$: Actions,
    private readonly service: OrganizationsService
  ) {
  }

}
